'use strict';

exports.__esModule = true;
exports.default = getCollapserStyles;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple utility function to get the dynamic collapser styles.
 */
function getCollapserStyles(_ref) {
  var _ref2;

  var flipped = _ref.flipped,
      suffix = _ref.suffix,
      suffixFlipped = _ref.suffixFlipped;

  for (var _len = arguments.length, classNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classNames[_key - 1] = arguments[_key];
  }

  return _classnames2.default.apply(undefined, ['md-collapser', (_ref2 = {
    'md-collapser--flipped': flipped && (!suffixFlipped || !suffix)
  }, _ref2['md-collapser--' + suffix] = suffix, _ref2['md-collapser--' + suffix + '-flipped'] = suffix && flipped && suffixFlipped, _ref2)].concat(classNames));
}


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/utils/getCollapserStyles.js
// module id = 129
// module chunks = 168707334958949